import React from "react";
import { Card, Modal } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Button from "react-bootstrap/Button";

import Col from "react-bootstrap/Col";
import { useDispatch, useSelector } from 'react-redux';
import { setReconnect,fetchDataServiceMeterCategory,notificationDetails } from './stateManegement/dispatch';
import { useForm } from "react-hook-form"

export default function Reconnection({ userData }) {

  const dispatch = useDispatch();
  const { loading, serviceAndMeterCat, apierror,returnData } = useSelector((state) => state.notificatinReducer);
  useEffect(() => {
    dispatch(fetchDataServiceMeterCategory(userData));
  }, [dispatch]);
  
  const {
    register,
    handleSubmit,
    watch,
    reset,
    setValue,
    formState: { errors },
  } = useForm()
  const [inputValues, setInputValues] = useState({});
  const [inputValues2, setInputValues2] = useState({});
  const [inputValues3, setInputValues3] = useState({});
  const [inputValues4, setInputValues4] = useState({});
  const [getAlldetails, setGetAlldetails] = useState()

 
  const [checkedRows, setCheckedRows] = useState({

    InputNotification: false,
    NotificationGeneration: false,
    AlloftheAbove: false,
  });
  const [balanceValue, setBalanceValue] = useState({

    InputNotification: "",
    NotificationGeneration: "",
    AlloftheAbove: "",
  });
 // Function to reset all values
 const resetAllValues = () => {
  // Reset selected options
  // Reset checked rows
  setCheckedRows({

    InputNotification: false,
    NotificationGeneration: false,
    AlloftheAbove: false,
  });

  // Reset balance values
  setBalanceValue({

    InputNotification: "",
    NotificationGeneration: "",
    AlloftheAbove: "",
  });
};

  const handleBalanceValue = (value) => (e) => {
    setBalanceValue({
      ...balanceValue,
      [value]: e.target.value,
    });
  };

  const onSubmit = async (data) => {
    console.log(getAlldetails)
    const {
      STATE_NAME: state,
      CIRCLE_NAME: district,
      CIRCLE_CODE: circleCode,
      USERNAME: userName
    } = userData.pDATASET[0];
  
    const getNotificationFrequency = (everyEvent = 0) => ({
      everyEvent
    });
  
    const newObj = {
      state,
      district,
      circleCode,
      userName,
      serviceCategory: data.serviceCategory,
      meterCategory: data.meterCategory,
      reconnectionConsideration: {
        inputNotification: {
          enabled: getAlldetails.INPUTNOTIFICATION ? 1 : 0,
          notificationFrequency: getNotificationFrequency(getAlldetails.INPUTNOTIFICATION ? 1 : 0)
        },
        notificationGeneration: {
          enabled: getAlldetails.NOTIFICATIONGENERATION ? 1 : 0, 
     
          notificationFrequency: getNotificationFrequency(getAlldetails.NOTIFICATIONGENERATION ? 1 : 0),
        },
        allOfTheAbove: {
          enabled: getAlldetails.ALLOFTHEABOVE ? 1 : 0,
     
          notificationFrequency: getNotificationFrequency(getAlldetails.ALLOFTHEABOVE ? 1 : 0,),
        },
      },
    };    
    try {
      await dispatch(setReconnect(userData, newObj));
      window.alert("Reconnection submitted successfully!");
      reset();
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };
  const handleCheck = (row) => (e) => {
    const { name, checked } = e.target;
    
    if (name === "ALLOFTHEABOVE") {
      // If "All of the Above" is checked, check all other boxes
      setGetAlldetails({
        ...getAlldetails,
        INPUTNOTIFICATION: checked,
        NOTIFICATIONGENERATION: checked,
        ALLOFTHEABOVE: checked,
      });
    } else {
      // For individual checkboxes, update their state
      setGetAlldetails({
        ...getAlldetails,
        [name]: checked,
        // Deselect "All of the Above" if any individual checkbox is unchecked
        ALLOFTHEABOVE: getAlldetails?.INPUTNOTIFICATION && getAlldetails?.NOTIFICATIONGENERATION && checked,
      });
    }
  };
  


    // Watch the values of both selects
    const ServiceCategory = watch("serviceCategory");
    const MeterCategory = watch("meterCategory");
      const handleSelectChange = async (ServiceCategory, MeterCategory) => {
        try {
          // Wait for the dispatch to complete
          let apiID = 8
          await dispatch(notificationDetails(userData, ServiceCategory, MeterCategory,apiID));
          console.log(returnData)
         
        } catch (error) {
          // Handle error if needed
          console.error("An error occurred:", error);
        }
      };
      useEffect(() => {
        if (returnData?.pDATASET?.[0]) {
          setGetAlldetails(returnData.pDATASET[0]);
          console.log("Disconnection value updated:", returnData.pDATASET[0]);
        }else{
          setGetAlldetails(returnData?.pDATASET?.[0]);
        }
      }, [returnData]);
    
    // Call `handleSelectChange` whenever `ServiceCategory` or `MeterCategory` changes
    useEffect(() => {
      if (ServiceCategory?.length != 0 && MeterCategory?.length != 0) {  // Ensure these are not undefined or null
       
        handleSelectChange(ServiceCategory,MeterCategory);
      }
    
    }, [ServiceCategory, MeterCategory]);  // Include userData as a dependency


  return (
    <>
      <Card
        style={{
          height: "auto",
          width: "100%",
          backgroundColor: "#17234D",
          borderRadius: "0px",
        }}
      >
        <Card.Body>
          <Card.Title
            style={{
              color: "#fff",
              fontFamily: "Roboto-Regular",
              fontSize: "25px",
            }}
          >
            Notification Management - Reconnection
          </Card.Title>
        </Card.Body>
      </Card>

      <div className="TriffContainer">
        <Card
          style={{ boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)", margin: "30px" }}
        >
          <Card className="custom_card">
            <>
              {" "}
              <div className="custom_container">
                <Form onSubmit={handleSubmit(onSubmit)}>
                  <Card className="custom_top_container">
                    <Row>
                      <Col className="customtitle" sm={2}>
                        {" "}
                        State
                      </Col>
                      <Col className="customtitle" sm={2}>
                        {" "}
                        Distict
                      </Col>
                    </Row>
                    <Row>
                    <Col sm={2} style={{ fontFamily: "Roboto-Regular ", fontSize: '15px' }} >
                  <input className="inputHide" defaultValue={userData.pDATASET[0].STATE_NAME}   value={userData.STATE_NAME} /> 
                  
                  </Col>
                  <Col sm={2} style={{ fontFamily: "Roboto-Regular", fontSize: '15px' }}  >
                  <input className="inputHide"   defaultValue={userData.pDATASET[0].CIRCLE_NAME}  value={userData.CIRCLE_NAME}  /> 
                  
                  </Col>
                    </Row>{" "}
                  </Card>
                  <div className="customContainer">
                    <div style={{display:"flex", gap:"20px"}}>
                      <div className="mb-3 gap-5 dropdowncustom">
                        <Form.Group>
                          <Form.Label>Service Category</Form.Label>
                          <Form.Select {...register("serviceCategory",{ required: "This is required." })} aria-label="Default select example">
                            <option value="">Select Service Category</option>
                            {serviceAndMeterCat?.pDATASET?.filter(item => item.TYPE === "SERVICECATEGORY").map(service => (
                              <option key={service.ID} value={service.ID}>
                                {service.NAME}
                              </option>
                            ))}
                          </Form.Select>
                          {errors.serviceCategory && <span className="error">This field is required</span>}
                        </Form.Group>
                      </div>
                      <div className="mb-3 gap-5 dropdowncustom">
                        <Form.Group>
                          <Form.Label>Meter Category</Form.Label>
                          <Form.Select {...register("meterCategory")} aria-label="Default select example">
                            <option value="">Select Meter Category</option>
                            {serviceAndMeterCat?.pDATASET?.filter(item => item.TYPE === "METERCATEGORY").map(service => (
                              <option key={service.ID} value={service.ID}>
                                {service.NAME}
                              </option>
                            ))}
                          </Form.Select>
                          {errors.meterCategory && <span className="error">This field is required</span>}
                        </Form.Group>
                      </div>
                    </div>
                   


                    <div className="mb-3 pt-3 row_card">
                      <div className="par_card">
                        <div className="checkwithinput">
                          <h6>Reconnection
                          Consideration</h6>

                       
                          <Form.Group className="checkinput">
                            <Form.Check
                              inline
                              {...register("InputNotification")}
                              label="Input Notification"
                              name="INPUTNOTIFICATION"
                              checked={getAlldetails?.INPUTNOTIFICATION}
                              onChange={handleCheck("InputNotification")} // Handle specific row
                            />
                   
                          </Form.Group>

                          <Form.Group className="checkinput">
                            <Form.Check
                              inline
                              {...register("NotificationGeneration")} 
                              label="Notification Generation"
                              name="NOTIFICATIONGENERATION"
                              checked={getAlldetails?.NOTIFICATIONGENERATION}
                              onChange={handleCheck("NotificationGeneration")} // Handle specific row
                            />
                             
                          
                          </Form.Group>

                          <Form.Group className="checkinput">
                            <Form.Check
                              inline
                              {...register("AlloftheAbove")} 
                              label="All of the Above"
                              name="ALLOFTHEABOVE"
                              checked={getAlldetails?.ALLOFTHEABOVE}
                              onChange={handleCheck("AlloftheAbove")} // Handle specific row
                              
                            />
                           
                            
                          </Form.Group>
                        </div>

                        <div className="checkBoxs">
                          <h6 style={{paddingBottom: "40px"}}>Notification Frequency</h6>

                          <Col  >
                            <div className="checkrows">
                                <Form.Group>
                                  <Form.Check
                                      
                                    inline
                                    {...register("InputNotificationEveryEvent")}

                                    label="Every Event"
                                    name="InputNotificationEveryEvent"
                                    checked={getAlldetails?.INPUTNOTIFICATION}
                                 
                                
                                    disabled={!getAlldetails?.INPUTNOTIFICATION}
                                
                                  />
                                </Form.Group>
    
                              
                            </div>
                          </Col>
                          <Col>
                            <div className="checkrows">
                                <Form.Group>
                                  <Form.Check
                                    inline
                                    label="Every Event"
                                    name="NotificationGenerationEveryEvent"
                                    {...register("NotificationGenerationEveryEvent")}
                                    checked={getAlldetails?.NOTIFICATIONGENERATION}
                                    disabled={!getAlldetails?.NOTIFICATIONGENERATION}
                                  />
                                </Form.Group>
                              
                            </div>
                          </Col>
                          <Col >
                            <div className="checkrows">
                                <Form.Group>
                                  <Form.Check
                                    inline
                                    label="Every Event"
                                    {...register("AlloftheAboveEveryEvent")}
                                    value="AlloftheAboveEveryEvent"
                                
                                    name="AlloftheAboveEveryEvent"
                                    checked={getAlldetails?.ALLOFTHEABOVE}
                                    disabled={!getAlldetails?.ALLOFTHEABOVE}
                                 
                                  />
                                </Form.Group>
                          
                            </div>
                          </Col>
                        </div>
                      </div>
                    </div>
                    <div className="d-flex gap-3" style={{ marginTop: 40, marginLeft: "10px" }}>
                    <div className="btn_div" >

<button className="btn btn-primary"
  type="button"
  onClick={() => {
    reset(); // Clears all form fields to default (empty) values
  }}
>
  Clear All
</button>

<input className="btn btn-primary" type="submit" value="SUBMIT" />
{/* <Button variant="primary" onClick={handleSubmit}>Submit</Button> */}
</div>
       
                  </div>
                  </div>
                 
                </Form>
              </div>
            </>
          </Card>
        </Card>
      </div>
    </>
  );
}
